import styled, { keyframes } from 'styled-components';
import { FaSpinner } from 'react-icons/fa'
import { Link } from 'react-router-dom';

export const AgenticContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  min-height:80vh;
  max-height: 90vh;
  width: 100%;
  overflow-y: hidden;
`;
export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(FaSpinner)`
  // position: fixed;
  // margin-right: 25px;
  font-size: 24px;
  font-weight: bold;
  animation: 2s linear ${spin} infinite;
  z-index: 9999;
  color: black;
`;

export const FormH1 = styled.h1`
  margin-top: 90px;
  position: sticky;
  margin-bottom: 10px;
  padding: 1rem;
  background-color: transparent;
  color: #006ee6;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;

export const History = styled.div`
  flex: 1;
  width: 60%;
  padding: 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 490px){
    max-width: 400px;
  }
`;

export const Message = styled.div`
  align-self: ${(props) => (props.role === "user" ? "flex-end" : "flex-start")};
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 8px;
  max-width: 70%;
  color: white;
  text-align: ${(props) => (props.role === "user" ? "right" : "left")};
  background-color: ${(props) =>
    props.role === "user" ? "#006ee6" : "#222831"};
`;


export const InputWrapper = styled.div`
  display: flex;
  bottom: 0;
  z-index: 10;
  position: sticky;
  padding: 1rem;
  background-color: transparent;
  border-top: 1px solid #ddd;
  justify-content: center;
  width: 60%;
`;
// export const InputWrapper = styled.div`
//   width: 100%;
//   padding: 1rem;
//   border-top: 1px solid #ddd;
//   background-color: #f5f5f5;
//   display: flex;
//   justify-content: center;
//   position: sticky;
//   bottom: 0;
//   z-index: 10;
// `;

export const InputCard = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 28px;
  box-shadow: rgba(0, 0, 0, 0.18) 0px 10px 24px;
  padding: 0.5rem 1rem;
  @media screen and (min-width: 490px){
    min-width: 800px;
  }
`;

export const ExpandingTextarea = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  padding: 0.75rem 1rem;
  resize: none;
  overflow-y: auto;
  line-height: 1.5;
  max-height: 200px;
  
  @media screen and (min-width: 490px){
    font-size: 1rem;
  }
`;


export const SendButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #0078d4;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
`;

export const ClearButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #d400007c;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
`;

export const SlateContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#010606')};
  padding: 80px 20px;
  background-size: 100% auto;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  text-align: center;
  min-width: 120px;
  align-items: center;
`;

export const TopLine = styled.div`
  color: #006ee6;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 4px;
  margin-top: 2px;

  @media screen and (min-width: 490px){
    margin-top: 5px;
    margin-bottom: 16px;
  }
`;

export const Form = styled.form`
  background: #f5f5f5;
  height: auto;
  display: grid;

  @media screen and (min-width: 490px) {
    padding: 24px 24px;
    width: 100%;
    max-width: 400px;
  }
`;

export const FormH4 = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  font-size: 12px;
  color: ${({ errorText }) => (errorText ? 'red' : '#f5f5f5')};
  font-weight: bold;
  text-align: center;
`;

export const CardContainer = styled.div`
  display: grid;
  grid-gap: 20px;
  padding: 20px 0;
  background-color: #f5f5f5;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  max-width: 900px;
  margin: 0 auto;
  @media screen and (max-width:490px){
    max-width: 200px;
    height: 500px;
    overflow: auto;
  }
`;

export const Card = styled.div`
  background-color: #222831;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;
  min-width:120px;

  @media screen and (min-width:490px){
    height: 200px;
  }
`;

export const LinkButton = styled(Link)`
  padding: 0.5rem 1rem;
  background-color: #0078d4;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
`